import React, { Component } from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import Responsive from '../components/Responsive';
import MessengerList from '../components/views/messenger/MessengerList';
import MessengerView from '../components/views/messenger/MessengerView';
import HttpServices from '../utils/Http.services';
import { checkDefaultTab, chooseFontColor, conditionalWidth, translate } from '../utils/useful';
import SocketServices from '../utils/socket.services';
import GroupInformation from '../components/views/messenger/info/GroupInformation';
import ContactInfo from '../components/views/messenger/sideBar/ContactInfo';
import SidebarView from '../components/SidebarView';
import Modal from '../components/Modal';
import Topics from '../components/views/messenger/sideBar/Topics';
import ForwardList from '../components/views/messenger/sideBar/ForwardList';
import TopicInfo from '../components/views/messenger/sideBar/TopicInfo';
import MessengerAdminView from './Applets/MessengerAdminView';
import HeaderDrivePortal from '../components/header/HeaderDrivePortal';
import HeaderPortal from '../components/header/HeaderPortal';
import SelectApplet_ from '../components/useful/SelectApplet_';
import PortalScopeSelector from '../components/header/PortalScopeSelector';

class MessengerPortal extends Component {

    state = {
        stage: 1,
        messengerInfo: false,
        topics: [],
        isLoader: false,
        colors: {
            primaryColor: '#0085ff',
            secondaryColor: '#5BABF5',
            textColor: '#fff'
        }
    }

    componentDidMount() {
        this.init()
        // this.checkDefaultTab()
    }


    // checkDefaultTab = () => {
    //     checkDefaultTab(this.props.windowData, this.props.baseUrl, this.state.modules, this.props.width, (pageInfo, pageType, def) => {
    //         def = def ?? ''
    //         pageType = pageType != null ? pageType : def
    //         if (pageType != null) {
    //             this.setState({ oldData: this.props.windowData, path: def, pageType: pageType }, () => {
    //                 setTimeout(() => {
    //                     this.setState({ page: pageInfo, pageType, headers: pageInfo?.fields ?? pageInfo?.headers, pageStatus: 200 }, () => {
    //                         if (this.stageManager && ['main', 'settings'].includes(pageType)) {
    //                             this.stageManager.changeStage((pageType), () => {
    //                             })
    //                         }
    //                         else {
    //                             this.checkUrlMessenger(0, pageType)
    //                         }
    //                     })
    //                 }, 10);
    //             })
    //         } else {
    //             this.setState({ pageStatus: 404 })
    //         }
    //     })
    // }


    componentDidUpdate(prevProps) {
        if (JSON.stringify(this.props.data) !== JSON.stringify(prevProps.data)) {
            // setTimeout(() => {
            this.init()
            // }, 500);
        }

        if (this.props.user?.info?._id != prevProps.user?.info?._id) {
            this.init()
        }
        if ((JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path))) {
            this.setState({ oldData: this.props.windowData }, () => {
                // this.checkDefaultTab()
            })
        }
    }

    init() {
        setTimeout(() => {
            this.setHeader()

        }, 10);
    }

    setHeader = (key, value) => {

        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: false,
                    // showFrames: 'static',
                    headerIdentityComponent: this.headerIdentityComponent
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                // console.log({ ...this.state.headerConfig, [key]: value })

                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }



    setData = (key, value, reference, cb) => {
        if (reference == 'Messenger') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }





    headerIdentityComponent = () => {

        // let portalImage = '/assets/icons/portals/chat (2).png'
        let portalName = translate("Messenger Portal")
        return (
            <div className='flexc' >
                <button className='flexc' onClick={() => this.changePage()} >
                    <p className=' text-semibig text-semibold' style={{ whiteSpace: "nowrap", color: '#fff' }} >{portalName}</p>
                </button>

                <div className="mx-2  flexc">

                    <PortalScopeSelector type='messenger' language={this.props.language} width={this.props.width} userPerspective={this.props.userPerspective} sections={this.props.sections} modules={this.props.modules} changePage={this.props.changePage} functionsHandler={this.functionsHandler} colors={this.state.colors} frames={this.props.frames} variables={this.props.variables} updateFrames={this.props.updateFrames} />

                    {/* <SelectApplet_ ref={el => this.selectApplet = el} type='messenger' setData={this.setCurrentApplet} language={this.props.settings?.language} colors={this.props.colors} /> */}
                </div>

            </div>
        )
    }



    functionsHandler = (type, name, data, info) => {


        // console.log(type, name, data, info)
        if (type) {
            if (type == 'admin') {
                this[name](data, info)
            } else {
                if (this[type] && this[type][name]) {
                    this[type][name](data)
                }
            }
        } else {
            if (this[name]) {
                this[name](data, info)
            }
        }
    }


    changeScope = (data) => {
        // console.log(data)
        this.setState({ currentScope: data })
    }



    changePage = (page, info) => {

        // console.log("changePage", page)
        let extraPath = Array.isArray(page) ? page : [page]
        let fullPath = [...this.props.baseUrl, ...extraPath]
        this.changeWindow(fullPath, info)

    }


    changeWindow = (list, info) => {

        if (Array.isArray(list)) {
            let finalList = []
            list.forEach(value => {
                let one = value
                if (/\{\{(.*?)\}\}/.test(value)) {
                    if (this.props.variables) {
                        one = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                }
                if (one) {
                    finalList.push(one)
                }
            });

            // console.log(finalList)

            let data = { type: 'applet', path: finalList }
            if (info) {
                data.params = info
            }

            // console.log(data)

            this.props.changeWindow('applet', data)
        }
    }


    


    render() {

        let variables = {
            applet: this.state.currentApplet,
            appletId: this.state.currentApplet?._id,
            appletHub: this.state.currentHub?._id
        }

        let colors = this.state.colors ?? {}
        let applet = this.state.applet

        // if (applet?.colorType == 'sameAsHub') {
        //     if (this.props.user.info?.colors) {
        //         colors = this.props.user.info.colors
        //     }
        // }

        if (applet?.colorType == "custom" && applet?.colors) {
            colors = applet?.colors
        }

        // if (!colors?.textColor) {
        //     colors.textColor = '#fff'
        // }

        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false
        // console.log(chooseFontColor(colors.textColor),colors.textColor )
        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`


        return (
            <div className="bg-white w-100 d-flex flex-column window-content-radius h-100"   >


                <div style={{ position: 'relative', top: 0 }}>
                    <HeaderPortal ref={el => this.header = el} config={this.state.headerConfig} currentHub={this.state.currentHub} currentApplet={this.state.currentApplet} currentFrame={this.state.currentFrame} isPortal={true} changeNav={this.changeNav} setCurrentApplet={this.setCurrentApplet} frames={this.state.modules} appletType={this.props.type} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} isDesktop={this.props.isDesktop} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.state.applet} width={this.props.width} colors={colors} features={this.props.applet?.features} setHeader={this.setHeader} backActionMobile={this.backActionMobile} portalImage={'/assets/icons/portals/chat (2).png'} portalName={translate("Messenger Portal")} />
                </div>
                <div className='flex-1 ' style={{minHeight:0}}>
                    <MessengerAdminView stageName={'messenger'}  scope={this.state.currentScope} permissionLevel={this.props.permissionLevel} isMobile={this.props.isMobile} permissions={this.props.permissions} changeWindow={this.changeWindow} changePage={this.changePage} updateFrameInfo={this.updateFrameInfo} setData={this.setData} setHeader={this.setHeader} colors={colors} width={this.props.width} height={this.props.height} modules={this.state.modules} formPages={this.state.page?.formPages} page={this.state.page} windowData={this.props.windowData} baseUrl={[...this.props.baseUrl]} applet={this.props.applet} headers={this.state.headers} automations={this.props.automations} language={this.props.language} userSettings={this.state.userSettings} lastStagePage={this.lastStagePage} changeWindowLink={this.props.changeWindowLink} changeStage={this.changeStage} goToHub={this.props.goToHub} variables={variables} functionsHandler={this.functionsHandler} appletAccess={this.props.appletAccess} updateUserSettings={this.props.updateUserSettings} isApplet={false} />
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user, messengers: state.messengers })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MessengerPortal);